import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription, finalize, take } from 'rxjs';
import { LoadingService } from '../../loading/loading.service';
import { EntitiesService } from 'src/app/modules/services/entities/entities.service';
import { Location } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { ModalComponent } from '../../modal/modal.component';
import { ModalHistoricComponent } from 'src/app/modules/shared/modals/modal-historic/modal-historic.component';
import { StatesService } from 'src/app/modules/services/states/states.service';
import { ToastService } from 'src/app/modules/services/toast/toast.service';
import { FormatUtilsService } from 'src/app/modules/services/format-utils/format-utils.service';
import { cnpjValidator } from 'src/app/modules/shared/validators/cnpj-validador';
import { ModalController } from '@ionic/angular';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { AuthService } from 'src/app/modules/services/auth/auth.service';
import { UserService } from 'src/app/modules/services/user/user.service';


@Component({
  selector: 'app-entitie-form',
  templateUrl: './entitie-form.component.html',
  styleUrls: ['./entitie-form.component.scss'],
})
export class EntitieFormComponent implements OnInit {
  @Input() isEditMode: boolean = false;
  entitieId: string | null = null;
  entitie: any;
  form: FormGroup;
  panelOpenState: boolean = false;
  panelOpenState2: boolean = false;
  panelOpenState3: boolean = false;
  entities: any[] = [];
  states: any[] = [];
  subsctiptions: Subscription[] = [];
  isConcessao: boolean = false;

  dadosBancarios: any[] = [];
  representantesLegais: any[] = [];
  enderecos: any[] = [];

  tipoEntidadeInput: string = '';
  selectTipoEntidadeId: any = null;

  estadoInput: string = '';
  selectEstadoId: any = null;
  hasNomeConcessao:boolean = true;
  hasEmail:boolean = true;
  hasFoneContato:boolean = true;
  hasMantenedora:boolean = true;
  tipoEntidadeNomeSelecionada = null;

  buttonInclusaoDisabled: boolean = false;
  buttonExclusaoDisabled: boolean = false;
  buttonEdicaoDisabled: boolean = false;
  restrictions: any[] = [];
  currentRoute: string = '';
  disabledTooltipMessage: string = 'Ação não permitida';
  isMaster: boolean = false;
  isMantenedora: boolean = false;
  isMobile: boolean = false;


  constructor(
    private cdr: ChangeDetectorRef,
    private router: Router,
    public dialog: MatDialog,
    private entitiesService: EntitiesService,
    private fb: FormBuilder,
    private loadingService: LoadingService,
    private route: ActivatedRoute,
    private location: Location,
    private statesService: StatesService,
    public toastService: ToastService,
    private formatUtilsService: FormatUtilsService,
    private modalCtrl: ModalController,
    private breakpointObserver: BreakpointObserver,
    private authService: AuthService,
    private userService: UserService,
  ) {
    this.statesService.getStates().subscribe((data) => {
      this.states = data;
    });
    this.form = this.fb.group({
      tipoEntidade: [''],
      tipoEntidadeId: [''],
      razaoSocial: ['', Validators.required],
      nomeConcessao: ['', Validators.required],
      cnpj: ['', [Validators.required, cnpjValidator()]],
      emailEntidade: ['', [Validators.email]],
      foneContatoEntidade: ['', Validators.required],
      nomeFantasia: [''],
      phone_fix: [''],
      mobile_phone: [''],
      informacoesAdicionais: [''],
      mantenedora: [false],
    });

    this.form.get('tipoEntidade')?.valueChanges.subscribe((value) => {
      this.onSelectionChange(value);
    });
  }

  ngOnInit(): void {
    this.getEntitieTypes();
    this.currentRoute = this.router.url;
    this.loadUserInfo();

    this.breakpointObserver.observe([Breakpoints.Handset]).subscribe(result => {
      this.isMobile = result.matches;
    });
    this.route.paramMap.subscribe((params) => {
      this.entitieId = params.get('id');
      if (this.entitieId) {
        this.loadEntitieData(this.entitieId);
      }else{
        const mantenedora = this.form.get('mantenedora');
        mantenedora?.disable();
      }
    });
  }
  loadUserInfo() {
    const userId = this.authService.getUserIdFromToken();
    if (userId) {
      this.userService.getMenuUsuario(userId).subscribe((response: any) => {
        const functionalities = response.profileUser.permissaoPerfis;

        functionalities.forEach((permission: any) => {
          const foundEntityFunctionality = this.findFunctionalityByName(
            permission.funcionalidade,
            'Entidades'
          );
          if (foundEntityFunctionality) {
            this.handleRestrictions(foundEntityFunctionality.restricoes);
          }
        });
      });
    }
  }
  findFunctionalityByName(functionality: any, targetName: string): any {
    if (functionality.nome === targetName) {
      return functionality;
    }

    if (
      functionality.subFuncionalidades &&
      functionality.subFuncionalidades.length > 0
    ) {
      for (let subFunctionality of functionality.subFuncionalidades) {
        const found = this.findFunctionalityByName(
          subFunctionality,
          targetName
        );
        if (found) {
          return found;
        }
      }
    }

    return null;
  }
  processSubFunctionalities(functionality: any) {
    if (
      functionality.subFuncionalidades &&
      functionality.subFuncionalidades.length > 0
    ) {
      functionality.subFuncionalidades.forEach((subFunctionality: any) => {
        if (
          subFunctionality.nome === 'Entidades' &&
          subFunctionality.restricoes
        ) {
          this.handleRestrictions(subFunctionality.restricoes);
        }
      });
    }
  }


  handleRestrictions(restrictions: any[]) {
    restrictions.forEach((restriction: { nome: string }) => {
      switch (restriction.nome) {
        case 'Inclusão':
          this.buttonInclusaoDisabled = true;
          break;
        case 'Exclusão':
          this.buttonExclusaoDisabled = true;
          break;
        case 'Edição':
          this.buttonEdicaoDisabled = true;
          break;
      }
    });

  }
  loadEntitieData(entitieId: string) {
    this.subsctiptions.push(
      this.entitiesService
        .getEntitie(entitieId)
        .pipe(
          take(1),
          finalize(() => {
            this.loadingService.hideLoading();
          })
        )
        .subscribe({
          next: (response: any) => {
            const entitie = response;
            this.entitie = entitie;
            this.populatingDataForm(entitie);
          },
          error: (erro: any) => {
            if (erro.status !== 500 && erro.status) {
              this.toastService.showError(erro.error.message);
            } else {
              this.toastService.showError();
            }
          },
        })
    );
  }

  populatingDataForm(entitie: any) {
    this.form.patchValue({
      tipoEntidade: entitie.tipoEntidade.nome,
      tipoEntidadeId: entitie.tipoEntidade.id,
      razaoSocial: entitie.razaoSocial,
      nomeConcessao: entitie.nomeConcessao,
      cnpj: this.formatUtilsService.formatCnpj(entitie.cnpj),
      cep: entitie.cep,
      endereco: entitie.endereco,
      estado: entitie.estado,
      estadoId: entitie.estado,
      cidade: entitie.cidade,
      bairro: entitie.bairro,
      numero: entitie.numero,
      emailEntidade: entitie.emailEntidade,
      foneContatoEntidade: this.formatUtilsService.formatPhoneNumber(
        entitie.foneContatoEntidade
      ),
      nomeFantasia: entitie.nomeFantasia,
      complementoEndereco: entitie.complementoEndereco,
      informacoesAdicionais: entitie.informacoesAdicionais,
      mantenedora: entitie.master ? true : entitie.mantenedora,
    });
    this.isMaster = entitie.master;
    this.isMantenedora = entitie.mantenedora;
    if (entitie.master) {
      this.form.disable();
    }
    this.tipoEntidadeInput = entitie.tipoEntidade.nome;
    this.selectTipoEntidadeId = entitie.tipoEntidade.id;

    this.estadoInput = entitie.estado;
    this.selectEstadoId = entitie.estado;

    this.dadosBancarios = entitie.informacoesFinanceiras;
    this.representantesLegais = entitie.representantesLegais;
    this.enderecos = entitie.enderecos;
    this.onSelectTipoEntidadeInput(entitie.tipoEntidade.nome);
  }
  getAllData() {
    this.subsctiptions.push();
  }

  onSelectTipoEntidadeInput(value: any) {
    this.setFormValue(value, 'tipoEntidade');
    const mantenedora = this.form.get('mantenedora');
    const foneContatoEntidade = this.form.get('foneContatoEntidade'); 
    const emailEntidade = this.form.get('emailEntidade'); 
    const nomeConcessao = this.form.get('nomeConcessao'); 
    this.tipoEntidadeNomeSelecionada = value;
    switch (value) {
      case 'Órgão público':
        this.hasNomeConcessao = false;
        this.hasEmail = false;
        this.hasFoneContato = false;
        this.hasMantenedora = true;
        foneContatoEntidade?.clearValidators();
        emailEntidade?.clearValidators();
        nomeConcessao?.clearValidators();
        this.form.patchValue({ foneContatoEntidade: '' });
        this.form.patchValue({ emailEntidade: '' });
        this.form.patchValue({ nomeConcessao: '' });
        this.form.patchValue({ mantenedora: false });
        if(this.isMaster || this.isMantenedora ){
          this.form.patchValue({ mantenedora: true });
        }
        mantenedora?.enable();
        emailEntidade?.updateValueAndValidity();
        foneContatoEntidade?.updateValueAndValidity();
        nomeConcessao?.updateValueAndValidity();
        break;

      case 'Supervisora':
        this.hasNomeConcessao = false;
        this.hasEmail = true;
        this.hasFoneContato = true;
        this.hasMantenedora = false;
        this.form.patchValue({ mantenedora: false });
        if(this.isMaster){
          this.form.patchValue({ mantenedora: true });
        }
        nomeConcessao?.clearValidators();
        foneContatoEntidade?.enable();
        foneContatoEntidade?.setValidators([Validators.required]);
        this.form.patchValue({ nomeConcessao: '' });
        emailEntidade?.enable();
        emailEntidade?.setValidators([Validators.email]);
      
        emailEntidade?.updateValueAndValidity();
        foneContatoEntidade?.updateValueAndValidity();
        nomeConcessao?.updateValueAndValidity();
        break;

      default:
        this.hasNomeConcessao = true;
        this.hasEmail = true;
        this.hasFoneContato = true;
        this.hasMantenedora = false;

        this.form.patchValue({ mantenedora: false });

        if(this.isMaster){
          this.form.patchValue({ mantenedora: true });
        }
        nomeConcessao?.setValidators([Validators.required]);

        foneContatoEntidade?.enable();
        foneContatoEntidade?.setValidators([Validators.required]);

        emailEntidade?.enable();
        emailEntidade?.setValidators([Validators.email]);

        emailEntidade?.updateValueAndValidity();
        foneContatoEntidade?.updateValueAndValidity();
        nomeConcessao?.updateValueAndValidity();
        break;
    }

  }

  onSelectTipoEntidadeId(value: any) {
    this.setFormValue(value, 'tipoEntidadeId');
  }

  onSelectEstadoInput(value: any) {
    this.setFormValue(value, 'estado');
  }

  onSelectEstadoId(value: any) {
    this.setFormValue(value, 'estadoId');
  }

  setFormValue(value: any, formInput: any) {
    if (value) {
      return this.form.patchValue({ [formInput]: value });
    }
    return this.form.patchValue({ [formInput]: null });
  }

  onSubmit() {
    if (!this.form.valid) {
      return this.toastService.showError('Campos obrigatórios não preenchidos');
    }

    this.isEditMode ? this.handleEditSubmit() : this.handleCreateSubmit();
  }

  handleEditSubmit() {
    const formData = this.formatFormData();
    this.loadingService.showLoading();

    this.entitiesService
      .editEntitie(this.entitieId, formData)
      .pipe(
        take(1),
        finalize(() => {
          this.loadingService.hideLoading();
        })
      )
      .subscribe({
        next: (res: any) => {
          this.toastService.showSuccess(res.message);
          this.goToListEntitie();
        },
        error: (erro: any) => {
          if (erro.status !== 500 && erro.status) {
            this.toastService.showError(erro.error.message);
          } else {
            this.toastService.showError();
          }
        },
      });
  }

  handleCreateSubmit() {
    const formData = this.formatFormData();
    this.loadingService.showLoading();

    this.entitiesService
      .registerEntitie(formData)
      .pipe(
        take(1),
        finalize(() => {
          this.loadingService.hideLoading();
        })
      )
      .subscribe({
        next: (res: any) => {
          this.toastService.showSuccess(res.message);
          this.goToListEntitie();
        },
        error: (erro: any) => {
          if (erro.status !== 500 && erro.status) {
            this.toastService.showError(erro.error.message);
          } else {
            this.toastService.showError();
          }
        },
      });
  }

  formatFormData() {
    const formValue = this.form.value;
    const id = this.isEditMode ? this.entitieId : '';

    const tipoEntidadeSelecionada = this.entities.find(
      (entitie) => entitie.nome == formValue.tipoEntidade
    );

    return {
      id: id,
      tipoEntidade: tipoEntidadeSelecionada ? tipoEntidadeSelecionada : {},
      razaoSocial: formValue.razaoSocial ? formValue.razaoSocial : '',
      nomeConcessao: formValue.nomeConcessao ? formValue.nomeConcessao : '',
      cnpj: formValue.cnpj ? formValue.cnpj : '',
      emailEntidade: formValue.emailEntidade,
      foneContatoEntidade: formValue.foneContatoEntidade,
      nomeFantasia: formValue.nomeFantasia,
      informacoesFinanceiras: this.dadosBancarios,
      representantesLegais: this.representantesLegais,
      informacoesAdicionais: formValue.informacoesAdicionais,
      enderecos: this.enderecos,
      mantenedora: this.isMaster ? true : formValue.mantenedora,
    };
  }

  goToListEntitie() {
    this.router.navigate(['/entidades']);
  }

  back() {
    this.location.back();
  }

  deleteEntite(entitieId: string | null) {
    const modalTitle: string = 'Excluir';
    const modalContent: string =
      'Você tem certeza que deseja excluir esta Entidade?';

    const dialogRef = this.dialog.open(ModalComponent, {
      data: {
        onPerformAction: this.onDeleteModalConfirm.bind(this),
        modalTitle: modalTitle,
        modalContent: modalContent,
        id: entitieId,
      },
    });
  }

  onDeleteModalConfirm(id: any): void {
    this.loadingService.showLoading();

    this.subsctiptions.push(
      this.entitiesService
        .deleteEntity(id)
        .pipe(
          finalize(() => {
            this.loadingService.hideLoading();
          })
        )
        .subscribe({
          next: (resp: any) => {
            this.toastService.showSuccess(resp.message);
          },
          error: (erro: any) => {
            if (erro.status !== 500 && erro.status) {
              this.toastService.showError(erro.error.message);
            } else {
              this.toastService.showError();
            }
          },
        })
    );
  }
  
  async viewstoryModal(entitieId: string | null) {
    const data = {
      type: 'entitie',
      id: entitieId,
      fieldMappings: {
        tipoEntidade: 'Tipo de Entidade',
        razaoSocial: 'Razão Social',
        nomeConcessao: 'Nome Concessão',
        cnpj: 'CNPJ',
        emailEntidade: 'E-mail',
        foneContatoEntidade: 'Fone de Contato',
        nomeFantasia: 'Nome Fantasia',
        informacoesFinanceiras: 'Informações Financeiras',
        representantesLegais: 'Representantes Legais',
        informacoesAdicionais: 'Informações Adicionais',
        enderecos: 'Endereços',
        mantenedora: 'Entidade Mantenedora',
      }
    }
    const modal = await this.modalCtrl.create({
      component: ModalHistoricComponent,
      componentProps: {
        data: data,
        fieldMappings: data.fieldMappings,
      },
    });

    modal.present();
  }

  getEntitieTypes() {
    this.subsctiptions.push(
      this.entitiesService
        .getEntitiesTypes()
        .pipe(take(1))
        .subscribe(
          (resp: any) => {
            this.entities = resp;
          },
          (erro) => {
            if (erro.status !== 500 && erro.status) {
              this.toastService.showError(erro.error.message);
            } else {
              this.toastService.showError();
            }
          }
        )
    );
  }
  onSelectionChange(tipoEntidade: any) {
    const form = this.form.value;

    if (tipoEntidade === 'Concessionaria') {
      this.isConcessao = true;
      this.form.get('nomeConcessao')?.setValidators(Validators.required);
    } else {
      this.isConcessao = false;
      this.form.get('nomeConcessao')?.clearValidators();
    }
    this.form.get('nomeConcessao')?.updateValueAndValidity();
  }

  onCheckboxKeydown(event: KeyboardEvent) {
    if (
      event.key === 'Spacebar' ||
      event.key === 'Enter' ||
      event.key === ' '
    ) {
      event.preventDefault();
      const checkbox = event.target as HTMLIonCheckboxElement;
      const isChecked = !checkbox.checked;
      this.form.get('mantenedora')?.setValue(isChecked);
    }
  }
}
